require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-institution-banco-interamericano-de-desarrollo.json") })
        }
      }, "path---es-mx-institution-banco-interamericano-de-desarrollo");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-institution-banco-interamericano-de-desarrollo!./.cache/json/es-mx-institution-banco-interamericano-de-desarrollo.json
// module id = 891
// module chunks = 231608221292675